// Shared "Transit-aware arrivals" toggle (persisted) used by Branch Forecast,
// Hub Dashboard and Forecast Planner. When on, H2H/Direct inbound lands on
// ship date + transit days instead of same-day.

import { useEffect, useState } from "react";

const KEY = "op.transitAware";

export function useTransitAware(): readonly [boolean, (v: boolean) => void] {
  const [on, setOn] = useState<boolean>(() => {
    try {
      const v = localStorage.getItem(KEY);
      return v === null ? true : v === "1"; // default ON; respect an explicit opt-out
    } catch {
      return true;
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(KEY, on ? "1" : "0");
    } catch {
      /* ignore */
    }
  }, [on]);
  return [on, setOn] as const;
}
